class Footer {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {    
                config: ""
            }, 
            options
        );    

         
        this.footer = element; 
 
        this.footer.querySelector("#news-subscribe-footer").addEventListener("click", () => {
            this.footer.querySelector("#news-subscribe-footer").classList.add("loading");
            let email =  document.querySelector("#email-footer-news").value;
            this.subBrevo(email, "footer"); 
        });  

    }   

    async subBrevo(email, source){   
        const call = await fetch(`https://kmv0qf41j4.execute-api.eu-west-3.amazonaws.com/Prod/brevo/subscribe/${email}/${source}`);  
        const rep = await call.json();    
        this.footer.querySelector("#news-subscribe-footer").classList.remove("loading");
        this.footer.querySelector(".newsletter-form .content-field").classList.add("hide");
        if(rep.success && !rep.data){
            this.footer.querySelector(".newsletter-form .success").classList.add("ok"); 
        }else if (!rep.success && rep.error == "already_exists"){
            this.footer.querySelector(".newsletter-form .success").classList.add("ok");
            this.footer.querySelector(".newsletter-form .success").textContent = "Vous faites déjà parti de nos abonné(e)s !";
        }else{
            this.footer.querySelector(".newsletter-form .success").classList.add("ok");
            this.footer.querySelector(".newsletter-form .success").textContent = "Désolé, une erreur s'est produite. Veuillez réessayer plus tard.";
        } 
 
    } 

     
} 
 
const footer = new Footer(document.querySelector(".footer"));